export default {
    setList(state, {notifications}){
        state.notifications = notifications.data
        state.total = notifications.total
        state.pages = notifications.last_page
    },
    setUnreadList(state, {notifications}){
        state.unreadNotifications = notifications.data
        state.total = notifications.total
        state.pages = notifications.last_page
    },
    setBellLoading(state, loading) {
        state.bellLoading = loading
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setConfig (state, { notifications }) {
        state.config = notifications
    }
}